import { createFileRoute, redirect } from "@tanstack/react-router";

interface CallbackSearchParams {
	code?: string;
}

export const Route = createFileRoute("/callback")({
	validateSearch: (search: Record<string, unknown>): CallbackSearchParams => ({
		code: typeof search.code === "string" ? search.code : undefined,
	}),
	beforeLoad: ({ search }) => {
		// If there's no 'code' parameter, redirect to home
		// WorkOS AuthKit adds this after successful OAuth
		if (!search.code) {
			throw redirect({ to: "/", replace: true });
		}
	},
	component: CallbackPage,
});

function CallbackPage() {
	// WorkOS AuthKit automatically processes the OAuth callback
	// when it detects a 'code' parameter in the URL.
	// The AuthProvider handles showing loading state during this process.
	// Once authentication completes, AuthKit redirects to the app root.
	return null;
}
